import { render, staticRenderFns } from "./UcContractValidityCard.yaml?vue&type=template&id=008c27bd&component"
import script from "./UcContractValidityCard.yaml?vue&type=script&lang=ts&component"
export * from "./UcContractValidityCard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports